<template>
    <section class="g-container || o-band">
        <div class="o-container">

            <app-intro class="u-d-flex align-items-center justify-content-between">
                <h3 class="u-mb-0">Storec gebruiker bewerken</h3>

                <router-link to="/admin/storec-mobiel" class="c-link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18.589" height="12.388" viewBox="0 0 18.589 12.388">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                            <path d="M17.589 6.223H4.714"/>
                            <path d="M7.439 10.989L1.001 6.195l6.438-4.8" stroke-linejoin="round"/>
                            <path d="M7.439 10.99L5.894 6.195l1.545-4.8" stroke-linejoin="round"/>
                        </g>
                    </svg>

                    Terug <span class="u-hidden-xsl-down">naar overzicht</span>
                </router-link>
            </app-intro>

            <div class="c-loading" v-if="loading">
                <spinner/>
                Bezig met laden van de gebruiker...
            </div>

            <transition-group name="fade" tag="section" v-if="!loading">
                <form v-on:submit.prevent="handleSubmit" class="form form---tint" novalidate key="form">
                    <div class="g-gap:2-xs g-gap:2-sm>sm || o-card">

                        <div class="form-fieldset">
                            <h4 class="u-mb-0">Gegevens</h4>

                            <!--<div class="form-group" :class="{ 'has-error': submitted && $v.form.Email.$error, 'has-success': submitted && !$v.form.Email.$error }">
                                <label class="u-sr-only" for="login-email">Email</label>
                                <input type="email" v-model="form.Email" id="login-email" name="Email" class="form-control" placeholder="Vul hier uw email in" />
                                <div v-if="submitted && $v.form.Email.$error" class="form-validation">
                                    <span v-if="!$v.form.Email.required">Email is verplicht</span>
                                    <span v-if="!$v.form.Email.email">Email is ongeldig</span>
                                </div>
                            </div>-->

                            <!--<div class="form-group" :class="{ 'has-error': submitted && $v.form.Naam.$error, 'has-success': submitted && !$v.form.Naam.$error }">
                                <label class="u-sr-only" for="register-name">Naam</label>
                                <input type="text" v-model="form.Naam" id="register-name" name="Naam" class="form-control" placeholder="Vul hier uw naam in" :disabled="disabled" />
                                <div v-if="submitted && $v.form.Naam.$error" class="form-validation">
                                    <span v-if="!$v.form.Naam.required">Naam is verplicht</span>
                                </div>
                            </div>

                            <div class="form-group" :class="{ 'has-error': submitted && $v.form.DefaultInitialen.$error, 'has-success': submitted && !$v.form.DefaultInitialen.$error }">
                                <label class="u-sr-only" for="register-initials">Initialen</label>
                                <input type="text" v-model="form.DefaultInitialen" id="register-initials" name="DefaultInitialen" class="form-control" placeholder="Vul hier uw initialen in" :disabled="disabled" />
                                <div v-if="submitted && $v.form.DefaultInitialen.$error" class="form-validation">
                                    <span v-if="!$v.form.DefaultInitialen.required">Initialen zijn verplicht</span>
                                </div>
                            </div>-->

                            <div class="form-group">
                                <label class="u-sr-only">Email:</label>
                                <div class="form-control-static">{{ form.Emailadres }}</div>
                            </div>

                            <div class="form-group">
                                <label class="u-sr-only">Naam:</label>
                                <div class="form-control-static">{{ form.Naam }}</div>
                            </div>

                            <div class="form-group">
                                <label class="u-sr-only">Initialen:</label>
                                <div class="form-control-static">{{ form.DefaultInitialen }}</div>
                            </div>
                        </div>

                        <div class="form-fieldset">
                            <h4 class="u-mb-0">Vestigingen</h4>

                            <div class="form-checkboxes">

                                <div class="custom-checkbox" v-for="(location, index) in form.StorecMobielGebruikerVestigingen" :key="location.VestigingID">
                                    <label :for="`location-${location.VestigingID}`" class="custom-control-label">
                                        <input type="checkbox" v-model="connectedLocations" :value="location.VestigingID" :name="`StorecMobielGebruikerVestigingen[${index}]`" :id="`location-${location.VestigingID}`" class="custom-control-input" />
                                        <span class="custom-control-name custom-control-name--reset">{{ location.Vestigingsnaam }}</span>
                                    </label>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="u-d-flex justify-content-between">
                        <a href="#0" class="c-btn c-btn--danger" @click.prevent="showModalConfirm">
                            <span v-show="status.deleting"><spinner/></span>
                            <span v-show="!status.deleting">Gebruiker verwijderen</span>
                            <svg v-show="!status.deleting" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 9.045 9.045">
                                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                                    <path d="M1.415 1.414L7.63 7.631"/>
                                    <path d="M7.632 1.414L1.415 7.631"/>
                                </g>
                            </svg>
                        </a>

                        <button type="submit" class="[ c-btn c-btn--info ] form-submit-btn" :disabled="status.updating">
                            <span v-show="status.updating"><spinner/></span>
                            <span v-show="!status.updating">Gebruiker wijzigen</span>
                            <svg v-show="!status.updating" xmlns="http://www.w3.org/2000/svg" width="14.875" height="14.875" viewBox="0 0 14.875 14.875">
                                <g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2">
                                    <path d="M1 7.438h12.875"/>
                                    <path d="M7.437 1v12.875"/>
                                </g>
                            </svg>
                        </button>
                    </div>
                </form>

                <modal key="modal-confirm" v-show="modal.visible" @close="closeModalConfirm">
                    <template v-slot:header>
                        <h4 class="u-mb-0">Weet je zeker dat je deze gebruiker wilt verwijderen?</h4>
                        <span class="delta || u-font-weight-normal || u-text-primary">{{ form.Naam }}, {{ form.Emailadres }}</span>
                    </template>

                    <template v-slot:body>
                        <form v-on:submit.prevent="deleteUser" class="form">

                            <div class="u-d-flex justify-content-end">
                                <button type="submit" href="#0" class="c-btn c-btn--danger">
                                    Ja, gebruiker verwijderen

                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 9.045 9.045">
                                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                                            <path d="M1.415 1.414L7.63 7.631"/>
                                            <path d="M7.632 1.414L1.415 7.631"/>
                                        </g>
                                    </svg>
                                </button>
                            </div>
                        </form>
                    </template>
                </modal>

            </transition-group>

        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import {
        required,
        email,
    } from 'vuelidate/lib/validators';
    import AppIntro from '../../components/app/AppIntro.vue';
    import Spinner from '../../components/Spinner.vue';
    import Modal from '../../components/Modal.vue';
    import normalizeFormData from '../../helpers/normalizeFormData';
    import { storecMobielService } from '../../services';

    export default {
        components: {
            Spinner,
            AppIntro,
            Modal,
        },
        data () {
            return {
                loading: true,
                submitted: false,
                disabled: false,
                connectedLocations: [],
                form: {
                    GebruikerMobielID: '',
                    Emailadres: '',
                    Naam: '',
                    DefaultInitialen: '',
                },
                modal: {
                    visible: false,
                    id: '',
                    name: '',
                },
            };
        },
        computed: {
            ...mapState('storecMobiel', ['status']),
        },
        validations: {
            form: {
                Emailadres: { required, email },
                Naam: { required },
                DefaultInitialen: { required },
            },
        },
        async created () {
            // get the user
            await this.getUser();

            // reset loading
            this.loading = false;
        },
        methods: {
            getUser () {
                return storecMobielService
                    .get(this.$route.params.id)
                    .then((result) => {
                        this.form = result;

                        // get the connected locations
                        const filtered = result.StorecMobielGebruikerVestigingen.filter((item) => item.Gekoppeld === 'Ja');
                        this.connectedLocations = filtered.map((item) => item.VestigingID);
                    }).catch(() => {
                        this.loading = false;
                    });
            },
            showModalConfirm () {
                this.modal.visible = true;
            },
            closeModalConfirm () {
                this.modal.visible = false;
            },
            async deleteUser (e) {
                const id = this.form.GebruikerMobielID;
                const data = normalizeFormData(e.target);

                await this.$store.dispatch('storecMobiel/deleteUser', { id, data });

                this.closeModalConfirm();
            },
            handleSubmit (e) {
                this.submitted = true;

                // validate the form
                this.$v.form.$touch();

                // if its still pending or an error is returned do not submit
                if (this.$v.form.$pending || this.$v.form.$error) return;

                // normalize form data
                const data = normalizeFormData(e.target);

                // get the id
                const id = this.$route.params.id;

                // kick off the update
                this.$store.dispatch('storecMobiel/updateUser', { id, data });
            },
        },

    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    /*.table {
        @include media-breakpoint-only(sm) {
            grid-template-columns: rem(150) 1fr;
            margin: 0;
            max-width: 100%;
        }
    }*/
</style>
